module.exports = __webpack_public_path__ + "01_short_gold.d5672709.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/01_short_gold.png
// module id = poms
// module chunks = 0